module.exports = __webpack_public_path__ + "static/media/lb-banner.21701f8a.png";


//////////////////
// WEBPACK FOOTER
// ./src/asset/image/product/lb-banner.png
// module id = 652
// module chunks = 0